import React, { FC } from "react";
import AsideEventCities from "./AsideEventCities";
import Event from "../../../modules/events/types/Event";

export interface AsideEventsSectionProps {
    event: Event;
    key: number;
}

const AsideEvent: FC<AsideEventsSectionProps> = ({
    event,
}) => {

    return (
        <>
            <h1 className="font-semibold text-2xl ">{event.name}</h1>
            <ul className="space-y-5 mt-10 mb-16">
                <AsideEventCities eventId={event.id} />
            </ul>
        </>
    );
};

export default AsideEvent;
